import { FC } from 'react'
import Register from "./register";
import Benefits from "./benefits";
import Disclaimer from "./disclaimer";
import Testimonials from "./testimonials";
import Prices from "./prices";

type Props = {
  renderForm: () => any
  content: GiftContent
}

export type GiftContent = {
  data?: any
  disclaimer: string
  title: string
  sub_title: string
  text: string
  gift_code?: string
  id: string
}

const Shared: FC<Props> = ({ renderForm, content }) => {

  return (
    <>
      <Register content={content} renderForm={renderForm} />
      {content?.data?.benefits ? <Benefits benefits={content.data.benefits} /> : null}
      {content?.data?.testimonials ? <Testimonials data={content.data.testimonials} /> : null}
      {content?.data?.prices ? <Prices data={content.data.prices} /> : null}
      {content?.disclaimer ? <Disclaimer inverted={content?.data?.invertedColors === 'true'} text={content.disclaimer} /> : null}
    </>
  )
}

export default Shared

